import {
  Button,
  Card,
  Divider,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { AppLogo } from 'components/Layout/AppLogo'
import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { TelemetryService } from './services/Telemetry'
import queryString from 'query-string'

import './AppError.scss'
import { useAuth0 } from '@auth0/auth0-react'
import { BeamerNotificationButton } from 'components/Common/NavigationBar/BeamerNotificationButton'

const messages = {
  consent_required:
    'your email account is not confirmed yet. Please check your mailbox.',
  login_required: 'unable to perform the login. Please try again',
  noOrganizations: 'user is not part of an organization.',
  invalidUser: 'current user is not valid in the platform.',
  maintenance: 'Platform under maintenance. Please, try again in a few moments',
}

const AppError = () => {
  const [timeToReload, setTimeToReload] = React.useState(120)
  const location = useLocation()
  const navigate = useNavigate()
  const auth0 = useAuth0()

  const getErrorType = () =>
    (location?.state && location.state['errorType']) ||
    queryString.parse(location.search)['errorType']

  const errorIs = (errorType: keyof typeof messages) =>
    getErrorType() === errorType

  useEffect(() => {
    TelemetryService.getInstance().logError({
      name: 'WebApplication error',
      message: location?.state
        ? location.state['error']?.error_description || 'undefined error'
        : getErrorType() || 'undefined error',
    })

    if (errorIs('login_required')) {
      navigate('/login')
    }

    const interval = setInterval(() => {
      setTimeToReload((time) => {
        if (time > 0) --time
        return time
      })
    }, 1000)

    return () => {
      clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (timeToReload <= 0) {
    if (auth0.isAuthenticated) {
      auth0.logout({ returnTo: window.location.origin })
    } else {
      navigate('/', { replace: true })
    }
  }

  const messageToShow =
    messages[getErrorType() || ''] || 'unknown error: ' + getErrorType()

  return (
    <div className="app-error">
      <BeamerNotificationButton
        style={{
          position: 'absolute',
          right: '1em',
          top: '1em',
          height: '32px',
          width: '32px',
          padding: '4px',
        }}
      />
      <Card className={'app-error-card'}>
        <div className="app-error-header">
          <AppLogo className="app-logo" />
        </div>
        <Divider />
        <div className="app-error-content">
          <Typography variant="subtitle1">
            {auth0.user?.given_name &&
              `${auth0.user.given_name} ${auth0.user.family_name},`}
          </Typography>

          <Typography variant="body1" style={{ textAlign: 'center' }}>
            <strong>{messageToShow}</strong>
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ textAlign: 'center' }}
          >
            {auth0.user && `logged in as ${auth0.user.email}`}
          </Typography>
        </div>
        <Divider />
        <div className={'app-error-footer'}>
          <Button
            onClick={async () => {
              // await AuthService.GetCurrent()?.Logout()
              auth0.logout({ returnTo: window.location.origin })
            }}
            variant="text"
            color="primary"
            size="large"
          >
            <ListItemText
              primary={`the app will reload in ${timeToReload}s`}
              secondary={'or click here to go to Rh24 start page'}
            />
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default AppError
